import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'input[max][type=number]',
  standalone: false,
})
export class MaxValueDirective {
  @Input() max!: number;

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (!this.max) {
      return;
    }

    const target = event.target as HTMLInputElement;
    const newValue = +target.value;

    if (!isNaN(newValue) && newValue > this.max) {
      target.value = this.max.toString();
    }
  }
}
